import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import cn from 'classnames'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import styles from './styles.module.scss'

const EditIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17}
      height={20}
      fill="none"
      {...props}
    >
      <path
        fill="#3E4552"
        d="M14 2.49v5.647l-3.482 3.943a.563.563 0 0 0-.255-.06h-6.51c-.315 0-.54.223-.54.508 0 .285.225.508.54.508h5.922L6.175 17H2.58C.866 17 0 16.175 0 14.518V2.49C0 .84.866 0 2.58 0h8.84C13.143 0 14 .84 14 2.49ZM3.754 9.166c-.316 0-.541.214-.541.5 0 .293.225.515.54.515h6.51c.3 0 .533-.222.533-.515 0-.286-.234-.5-.533-.5h-6.51Zm0-2.847c-.316 0-.541.222-.541.508 0 .285.225.507.54.507h6.51c.3 0 .533-.222.533-.507 0-.286-.234-.508-.533-.508h-6.51Zm0-2.854c-.316 0-.541.222-.541.507 0 .286.225.508.54.508h6.51c.3 0 .533-.222.533-.508 0-.285-.234-.507-.533-.507h-6.51ZM8.012 19.151l7.436-9.002-1.443-1.233-7.428 9.002-.568 1.765c-.054.187.153.382.33.296l1.673-.828Zm8.043-9.712.69-.836c.354-.421.338-.843-.038-1.163l-.284-.242c-.368-.32-.783-.242-1.128.164l-.698.835 1.458 1.242Z"
      />
    </svg>
  )
}

const ChevronIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={7}
      height={12}
      fill="none"
      {...props}
    >
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m1 10.25 4.624-4.625L1 1.001"
      />
    </svg>
  )
}

const ArrowIcon = (props) => {
  return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={8}
        height={7}
        fill="none"
        {...props}
      >
        <path
          fill="#0073DE"
          fillRule="evenodd"
          d="M3.793.293a1 1 0 0 1 1.414 0l2.5 2.5a1 1 0 0 1 0 1.414l-2.5 2.5a1 1 0 0 1-1.414-1.414l.793-.793H1a1 1 0 0 1 0-2h3.586l-.793-.793a1 1 0 0 1 0-1.414Z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  )
}

const AutoCreatedIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 7.71513C0 10.2642 1.26336 12.5409 3.28166 13.9629C3.6206 14.2201 4.052 14.1293 4.24459 13.8192C4.43717 13.5091 4.33703 13.1461 4.02119 12.9191C2.38806 11.7694 1.30958 9.87083 1.30958 7.71513C1.30958 4.16013 4.23688 1.28586 7.85749 1.28586C11.4781 1.28586 14.4054 4.16013 14.4054 7.71513C14.4054 9.87083 13.3269 11.7618 11.6938 12.9191C11.3779 13.1461 11.2778 13.5091 11.4704 13.8192C11.663 14.1293 12.0867 14.2201 12.4257 13.9705C14.4362 12.5712 15.715 10.2642 15.715 7.71513C15.715 3.45669 12.1945 0 7.85749 0C3.52046 0 0 3.45669 0 7.71513ZM13.7891 14.4773L11.3548 11.9811C10.9696 11.5878 10.5999 11.7543 10.4997 12.2459L9.89887 15.0899C9.81415 15.5135 10.0684 15.7707 10.5152 15.7102L13.4656 15.3018C13.9971 15.2261 14.1666 14.8782 13.7891 14.4773Z" fill="white" fill-opacity="0.85"/>
      <path d="M5.32396 10.8153C5.60128 10.8153 5.80158 10.6792 5.91712 10.3312L6.47947 8.72013H9.23731L9.79967 10.3312C9.91523 10.6792 10.1078 10.8153 10.3928 10.8153C10.7317 10.8153 10.9629 10.5959 10.9629 10.2934C10.9629 10.1724 10.932 10.0664 10.8782 9.90007L8.71345 4.18934C8.56712 3.79602 8.27438 3.5918 7.85068 3.5918C7.4347 3.5918 7.14967 3.79602 6.9956 4.18934L4.83864 9.90007C4.77702 10.0664 4.75391 10.1724 4.75391 10.2858C4.75391 10.6035 4.9773 10.8153 5.32396 10.8153ZM6.78761 7.81245L7.81216 4.88522H7.89693L8.92146 7.81245H6.78761Z" fill="white" fill-opacity="0.85"/>
    </svg>
  )
}

const ManualEntryIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.85749 15.9922C12.1945 15.9922 15.715 12.4096 15.715 7.9961C15.715 3.58256 12.1945 0 7.85749 0C3.52046 0 0 3.58256 0 7.9961C0 12.4096 3.52046 15.9922 7.85749 15.9922ZM7.85749 14.6595C4.23688 14.6595 1.30958 11.6806 1.30958 7.9961C1.30958 4.31162 4.23688 1.33269 7.85749 1.33269C11.4781 1.33269 14.4054 4.31162 14.4054 7.9961C14.4054 11.6806 11.4781 14.6595 7.85749 14.6595Z" fill="white" fill-opacity="0.85"/>
      <path d="M4.85347 11.6327C5.20783 11.6327 5.41582 11.3975 5.41582 10.9898V6.46655H5.48515L7.25694 10.982C7.37249 11.2642 7.54967 11.3975 7.8424 11.3975C8.1274 11.3975 8.32003 11.2642 8.42787 10.982L10.215 6.46655H10.2766V10.9898C10.2766 11.3897 10.4847 11.6327 10.8236 11.6327C11.1857 11.6327 11.3937 11.3975 11.3937 10.9898V4.98492C11.3937 4.55376 11.0932 4.25586 10.6696 4.25586C10.2998 4.25586 10.0532 4.42833 9.91465 4.76542L7.87321 9.97853H7.8347L5.77788 4.76542C5.64692 4.42833 5.40041 4.25586 5.03065 4.25586C4.59926 4.25586 4.29883 4.55376 4.29883 4.98492V10.9898C4.29883 11.3897 4.51453 11.6327 4.85347 11.6327Z" fill="white" fill-opacity="0.85"/>
    </svg>
  )
}

const PencilIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={14}
      fill="none"
      {...props}
    >
      <path
        fill="#fff"
        fillOpacity={0.85}
        d="M2.571 13.195 12.84 3.557l-1.647-1.556L.915 11.639.02 13.61c-.094.213.15.46.376.372l2.174-.787ZM13.668 2.797l.95-.876c.48-.45.51-.937.076-1.344l-.32-.3c-.423-.398-.941-.363-1.421.08l-.95.883 1.665 1.557Z"
      />
    </svg>
  )
}

const StoppedIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      {...props}
    >
      <path
        fill="#fff"
        fillOpacity={0.85}
        d="m13.02 15.218-2.708.387c-.403.058-.644-.187-.56-.59l.522-2.589 2.745 2.792ZM2.754 4.778a6.1 6.1 0 0 0-.905 3.218 6.12 6.12 0 0 0 2.5 4.953c.29.216.375.561.198.857-.17.295-.573.381-.885.136A7.325 7.325 0 0 1 .646 7.996a7.39 7.39 0 0 1 1.236-4.105l.873.887Zm12.337 3.218c0 1.511-.456 2.933-1.245 4.111l-.866-.88a6.13 6.13 0 0 0 .907-3.23c0-3.384-2.69-6.119-6.019-6.119a5.858 5.858 0 0 0-3.171.923l-.873-.887A7.101 7.101 0 0 1 7.87.654c3.987 0 7.223 3.29 7.223 7.342Z"
      />
      <path
        fill="#fff"
        fillOpacity={0.85}
        d="M6.86 8.955h-.252l-.524 1.533c-.107.331-.284.46-.538.46-.32 0-.525-.201-.525-.503 0-.108.022-.21.071-.367l.78-2.128.987 1.005ZM8.66 4.643l1.272 3.485-1.628-1.655-.394-1.168h-.078l-.173.511-.734-.746.156-.427c.135-.374.404-.569.78-.569.389 0 .658.195.8.569ZM13.98 15a.54.54 0 0 0 .771-.007.563.563 0 0 0 0-.785L1.764 1.006a.543.543 0 0 0-.778 0 .563.563 0 0 0 0 .785L13.98 15Z"
      />
    </svg>
  )
}

const getOriginalTimes = (selectedItem) => {
  if (Array.isArray(selectedItem?.work_time_history) && selectedItem.work_time_history.length) {
    const firstHistoryWorkChanges = [...selectedItem.work_time_history].reverse().find(i => i.works?.length)
    if (firstHistoryWorkChanges) {
      return {
        start: parseTime(firstHistoryWorkChanges.works[0].prev_start),
        end: parseTime(firstHistoryWorkChanges.works[0].prev_end),
      }
    }
  }
  return {
    start: parseTime(selectedItem?.started_at),
    end: parseTime(selectedItem?.finished_at),
  }
}

const dateFormatMap = {
  'DD.MM.YY': 'DD-MM-YYYY',
  'MM.DD.YY': 'MM-DD-YYYY',
  'YY.MM.DD': 'YYYY-MM-DD',
}

const parseTime = (time) => {
  return Object.values(dateFormatMap).reduce((acc, format) => {
    const parsedTime = moment(time, `${format} HH:mm`)
    if (parsedTime.isValid()) {
      acc = parsedTime.format('HH:mm')
    }
    return acc
  }, moment(time).format('HH:mm'))
}

const WorkTimeHistory = ({history, selectedItem}) => {
  
  const { t } = useTranslation()

  const [expnadedItems, setExpandedItems] = useState([])

  if (!selectedItem) {
    return null
  }

  const handleClickRow = (index, isExpanded) => () => {
    if (isExpanded) {
      setExpandedItems(expnadedItems.filter(i => i !== index))
      return
    }
    setExpandedItems([...expnadedItems, index])
  }

  const originalTimes = getOriginalTimes(selectedItem)
  const isExpandedCreated = expnadedItems.includes('created')
  const isExpandedStopped = expnadedItems.includes('stopped')

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <EditIcon />
        <div className={styles.headerTitle}>{t('Entry history')}</div>
      </div>
      {
        history.length
          ? <div className={styles.section}>
              <div className={styles.sectionTitle}>{t('Edited')}</div>
              {
                history.map((item, i) => {
                  const [changedWork] = item.works || []
                  const [changedBreak] = item.breaks || []
                  const changedPlace = (item.current_place_id || item.prev_place_id) && item.current_place_id !== item.prev_place_id
                  const changedJobType = (item.current_job_type_id || item.prev_job_type_id) && item.current_job_type_id !== item.prev_job_type_id
                  const changedBonus = (item.current_bonus || item.prev_bonus) && item.current_bonus !== item.prev_bonus
                  const isExpanded = expnadedItems.includes(`edit-${i}`)
                  return (
                    <div key={i} className={styles.historyItem}>
                      <div className={cn(styles.historyItemHeader, {[styles.expanded]: isExpanded})} onClick={handleClickRow(`edit-${i}`, isExpanded)}>
                        <div className={styles.historyItemIconContainer}>
                          <PencilIcon />
                        </div>
                        <div style={{flex: 1}}>
                          <div className={styles.historyItemTitle}>{item.changed_by.name} {item.changed_by.surname}</div>
                          <div className={styles.historyItemDate}>{moment(item.created_at).format('MM.DD.YYYY HH:mm')}</div>
                        </div>
                        <ChevronIcon style={{transform: `rotate(${isExpanded ? 90 : 0}deg)`}} />
                      </div>
                      {
                        isExpanded
                          ? <div className={styles.historyItemExpandedContent}>
                              {
                                changedPlace
                                  ? <div className={styles.historyItemContent}>
                                      <div>{t('Place')}</div>
                                      <div className={styles.historyItemChangedWork}>
                                        <div
                                          className={styles.noWrap}
                                          data-tooltip-id="comment"
                                          data-tooltip-content={item.prev_place_name}>{item.prev_place_name}</div>
                                        <ArrowIcon />
                                        <div
                                          className={styles.noWrap}
                                          style={{color: '#5798D5'}}
                                          data-tooltip-id="comment"
                                          data-tooltip-content={item.current_place_name}>{item.current_place_name}</div>
                                      </div>
                                    </div>
                                  : null
                              }
                              {
                                changedJobType
                                  ? <div className={styles.historyItemContent}>
                                      <div>{t('Job Type')}</div>
                                      <div className={styles.historyItemChangedWork}>
                                        <div className={styles.noWrap}>{item.prev_job_type_name}</div>
                                        <ArrowIcon />
                                        <div className={styles.noWrap} style={{color: '#5798D5'}}>{item.current_job_type_name}</div>
                                      </div>
                                    </div>
                                  : null
                              }
                              {
                                changedWork
                                  ? <div className={styles.historyItemContent}>
                                      <div>{t('Previous')}</div>
                                      <div className={styles.historyItemChangedWork}>
                                        <div>{parseTime(changedWork.prev_start)}</div>
                                        <ArrowIcon />
                                        <div>{parseTime(changedWork.prev_end)}</div>
                                      </div>
                                      <div>{t('Updated')}</div>
                                      <div className={styles.historyItemChangedWork}>
                                        <div style={{color: parseTime(changedWork.prev_start) !== parseTime(changedWork.start) ? '#5798D5' : '#333945'}}>{parseTime(changedWork.start)}</div>
                                        <ArrowIcon />
                                        <div style={{color: parseTime(changedWork.prev_end) !== parseTime(changedWork.end) ? '#5798D5' : '#333945'}}>{parseTime(changedWork.end)}</div>
                                      </div>
                                    </div>
                                  : null
                              }
                              {
                                changedBreak
                                  ? <div className={styles.historyItemContent}>
                                      <div>{t('Previous break')}</div>
                                      <div className={styles.historyItemChangedWork}>
                                        <div>{parseTime(changedBreak.prev_start)}</div>
                                        <ArrowIcon />
                                        <div>{parseTime(changedBreak.prev_end)}</div>
                                      </div>
                                      <div>{t('Updated break')}</div>
                                      <div className={styles.historyItemChangedWork}>
                                        <div style={{color: parseTime(changedBreak.prev_start) !== parseTime(changedBreak.start) ? '#5798D5' : '#333945'}}>{parseTime(changedBreak.start)}</div>
                                        <ArrowIcon />
                                        <div style={{color: parseTime(changedBreak.prev_end) !== parseTime(changedBreak.end) ? '#5798D5' : '#333945'}}>{parseTime(changedBreak.end)}</div>
                                      </div>
                                    </div>
                                  : null
                              }
                              {
                                changedBonus
                                  ? <>
                                      <div className={styles.historyItemContent}>
                                        <div>{t('Bonus')}</div>
                                        <div className={styles.historyItemChangedWork}>
                                          <div className={styles.noWrap}>{item.prev_bonus}</div>
                                          <ArrowIcon />
                                          <div className={styles.noWrap} style={{color: '#5798D5'}}>{item.current_bonus}</div>
                                        </div>
                                      </div>
                                      {
                                        item.bonus_comment
                                          ? <div className={styles.historyItemContent}>
                                              <div className={styles.noWrap} data-tooltip-id="comment" data-tooltip-content={item.bonus_comment}>
                                                {`${t('Bonus note:')} ${item.bonus_comment}`}
                                              </div>
                                            </div>
                                          : null
                                      }
                                    </>
                                  : null
                              }
                              {
                                item.manager_comment
                                  ? <div className={styles.historyItemContent}>
                                      <div className={styles.noWrap} data-tooltip-id="comment" data-tooltip-content={item.manager_comment}>
                                        {`${t('Admin note:')} ${item.manager_comment}`}
                                      </div>
                                    </div>
                                  : null
                              }
                            </div>
                          : null
                      }
                    </div>
                  )
                })
              }
            </div>
          : null
      }
      {
        selectedItem.stopped_employee
          ? (() => {
            const isChangedStart = moment(selectedItem.original_started_at).format('HH:mm') !== originalTimes.start
            const isChangedEnd = parseTime(selectedItem.stopped_at) !== originalTimes.end
            return (
              <div className={styles.section}>
                <div className={styles.sectionTitle}>{t('Stopped')}</div>
                <div className={styles.historyItem}>
                  <div className={cn(styles.historyItemHeader, {[styles.expanded]: isExpandedStopped})} onClick={handleClickRow('stopped', isExpandedStopped)}>
                    <div className={styles.historyItemIconContainer} style={{backgroundColor: '#DA5151'}}>
                      <StoppedIcon />
                    </div>
                    <div style={{flex: 1}}>
                      <div className={styles.historyItemTitle}>{`${selectedItem.stopped_employee.name} ${selectedItem.stopped_employee.surname}`}</div>
                      <div className={styles.historyItemDate}>{moment(selectedItem.stopped_at).format('MM.DD.YYYY HH:mm')}</div>
                    </div>
                    <ChevronIcon style={{transform: `rotate(${isExpandedStopped ? 90 : 0}deg)`}} />
                  </div>
                  {
                    isExpandedStopped
                      ? <div className={styles.historyItemExpandedContent}>
                          <div className={styles.historyItemContent}>
                            <div>{t('Stopped')}</div>
                            <div className={styles.historyItemChangedWork}>
                              <div>{moment(selectedItem.original_started_at).format('HH:mm')}</div>
                              <ArrowIcon />
                              <div style={{color: '#DA5151'}}>{moment(selectedItem.stopped_at).format('HH:mm')}</div>
                            </div>
                          </div>
                          {
                            selectedItem.edited_time
                              ? <div className={styles.historyItemContent}>
                                  <div>{t('Edited')}</div>
                                  <div className={styles.historyItemChangedWork}>
                                    <div style={{color: isChangedStart ? '#5798D5' : '#333945'}}>{originalTimes.start}</div>
                                    <ArrowIcon />
                                    <div style={{color: isChangedEnd ? '#5798D5' : '#333945'}}>{originalTimes.end}</div>
                                  </div>
                                </div>
                              : null
                          }
                        </div>
                      : null
                  }
                </div>
              </div>
            )
          })()
          : null
      }
      <div className={styles.section}>
        <div className={styles.sectionTitle}>{t('Created')}</div>
        <div className={styles.historyItem}>
          <div className={cn(styles.historyItemHeader, {[styles.expanded]: isExpandedCreated})} onClick={handleClickRow('created', isExpandedCreated)}>
            <div className={styles.historyItemIconContainer} style={{backgroundColor: selectedItem.createdBy ? '#0085FF' : '#57D05A'}}>
              {
                selectedItem.createdBy ? <ManualEntryIcon /> : <AutoCreatedIcon />
              }
            </div>
            <div style={{flex: 1}}>
              <div className={styles.historyItemTitle}>{selectedItem.createdBy ? `${selectedItem.createdBy.name} ${selectedItem.createdBy.surname}` : selectedItem.employee}</div>
              <div className={styles.historyItemDate}>{moment(selectedItem.created_at).format('MM.DD.YYYY HH:mm')}</div>
            </div>
            <ChevronIcon style={{transform: `rotate(${isExpandedCreated ? 90 : 0}deg)`}} />
          </div>
          {
            isExpandedCreated
              ? <div className={styles.historyItemExpandedContent}>
                  <div className={styles.historyItemContent}>
                    <div>{t('Time')}</div>
                    <div className={styles.historyItemChangedWork}>
                      <div>{originalTimes.start}</div>
                      <ArrowIcon />
                      <div>{originalTimes.end}</div>
                    </div>
                  </div>
                </div>
              : null
          }
        </div>
      </div>
      <ReactTooltip
        id='comment'
        variant='light'
        place='top-start'
        style={{backgroundColor: '#fff', fontSize: 12}}
        opacity={1}
        effect='solid'
      />
    </div>
  )
}

export default WorkTimeHistory
